import {type DefaultError, useMutation, useQueryClient} from "@tanstack/react-query";
import {queryHttp} from "~/query/queryHttp";
import {supplierEntityDetailUrl} from "../services/supplier360Urls";
import type {SupplierEntity} from "../types/Supplier360Types";

export type UpdateSupplierEntityCanonicalNameVariables = {
    entityId: number;
    canonical_name: string;
};

/**
 * `PATCH supplier_360/entity/{id}/` with `{canonical_name}` — docs §2.1 full CRUD.
 */
export function useUpdateSupplierEntityCanonicalNameMutation() {
    const queryClient = useQueryClient();

    return useMutation<SupplierEntity, DefaultError, UpdateSupplierEntityCanonicalNameVariables>({
        mutationFn: async ({entityId, canonical_name}) => {
            const {data} = await queryHttp.patch<SupplierEntity>(
                supplierEntityDetailUrl(entityId),
                {canonical_name},
            );
            return data;
        },
        onSuccess: (updated) => {
            queryClient.setQueryData([supplierEntityDetailUrl(updated.id)], updated);
            void queryClient.invalidateQueries({
                predicate: (query) => {
                    const key = query.queryKey[0];
                    return typeof key === 'string' && key.startsWith('supplier_360/entity');
                },
            });
        },
    });
}
